module.exports = __webpack_public_path__ + "img/heart_map_2x.145b5672.png";